// #docregion token
import { InjectionToken } from '@angular/core';
import { IAppConfig } from './IApp.config';
export { IAppConfig } from './IApp.config';
import { environment } from '../../environments/environment';
import { APP_ROLES_CONSTANT } from './app.constant';
import { UsersComponent } from '../modules/site/user/users/users.component';
export const APP_CONFIG = new InjectionToken<IAppConfig>('app.config');
// #enddocregion token
// #docregion config
export const APP_DI_CONFIG: IAppConfig = {
  site_name: environment.SITE_NAME,
  copyright_text: environment.COPYRIGHT_TEXT,
  version: environment.version,
  isVersionCheck: environment.isVersionCheck,
  build_version: environment.build_version,
  appLogo: 'assets/images/logo.svg',
  Is_E:'R3rcMGRoRsCuiU5TkzxTrUvPzihGQBr5h96aApNMALcRKxmjZ2Sg1MsH9gZva7zKA8n5p9qN0kSj4488LYW4X2FZDkCx4f8wbYGn8G7Ps69Cyd5vhQgtdL2wqBO4KW53tmXKlEb0Pjh/MY2gRcxB87KuTBWpxIeAo7SkOMMRAcE=',
  DEFAULT_PAGINATION_LIMIT: environment.DEFAULT_PAGINATION_LIMIT || 10,
  unassignedMaxDays: 7,
  UserRoleOptions: [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Customer' }
  ],
  UserRoleConstant: APP_ROLES_CONSTANT,
  UserRoleConstantMap: { 1: 'SuperAdmin', 2: 'Staff', 3: 'Customer' },
  PagingOptions: {
    pagingType: 'full',
    paginationLength: 20,
    lengthMenu: true,
    responsive: true
  },
  spinnerOptions: {
    type: 'line-scale',
    size: 'medium',
    bdColor: 'rgba(255, 255, 255, 0.3)',
    color: '#8ca4ef'
  },
  HelpMenus: {
    dashboard:'dashboard',
    billing:'billing',
    users:'account users',
    qrcode:'qrcode',
    addcode:'addcode',
    scheduletemplate: 'scheduletemplate',
    editschedule: 'editschedule',
    restrictiontemplates: 'restrictiontemplates',
    groups: 'groups',
    videocallgroups:'videocallgroup',
    addvideocallgroup:'addvideocallgroup',
    import: 'import',
    voicecallgroup:'voicecallgroups',
  },
  dtOptions : {
    paging: true,
    destroy: true,
    lengthChange: false,
    search: false,
    searching: false,
    serverSide: true,
    processing: false,
    pageLength: 20,
    responsive: true,
    pagingType: 'full',
    autoWidth: false,
    ordering: false,
    language: {
      info: "<div style='display:flex;justify-content:space-between;width:100%;'><div style='float:inline-end;' class='col-md-3'>_START_  -  _END_  of  _TOTAL_ </div><div style='float:inline-end;'>_PAGE_  / _PAGES_ </div></div>",
       emptyTable: 'No records found',
        paginate: {
          first: '<i class="fa fa-angle-double-left" style="font-size: 14pt;">',
          last: '<i class="fa fa-angle-double-right" style="font-size: 14pt;">',
          previous: '<i class="fa fa-angle-left" style="font-size: 14pt;">',
          next: '<i class="fa fa-angle-right" style="font-size: 14pt;">'
        },
    },
    drawCallback:(settings)=>
    {
    if(Math.ceil((settings.fnRecordsDisplay()) / settings._iDisplayLength) > 1)
    {
        $('.dataTables_paginate').show();
        $('.dataTables_info').show();  
        $('.dataTables_empty').hide();       
    }
    else
    {
        $('.dataTables_paginate').hide();
        $('.dataTables_info').hide();  
        $('.dataTables_empty').hide();       
        
    }
    },
  }
};
